export enum file_icons {
    'application/pdf' = 'assets/icons/pdf-icon.svg',
    'application/msword' = 'assets/icons/docx-icon.svg',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' = 'assets/icons/docx-icon.svg',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' = 'assets/icons/excel-icon.svg',
    'application/vnd.oasis.opendocument.spreadsheet' = 'assets/icons/ods-icon.svg',
    'text/csv' = 'assets/icons/csv-icon.svg',
    'application/zip' = 'assets/icons/zip-icon.svg',
    'image/jpeg' = 'assets/icons/jpg-icon.svg',
    'image/png' = 'assets/icons/png-icon.svg',
    'folder' = 'assets/icons/folder.svg',
};